export const PREPAYMENT_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PARTLY_PAID: 'partly_paid',
  OVERPAID: 'overpaid',
  FULLY_PAID: 'fully_paid',
  PAID: 'paid',
  CREDITED: 'credited',
  LINK_SENT: 'link_sent',
  LINK_EXPIRED: 'link_expired',
  PAYMENT_NON_TRACKABLE: 'payment_non_trackable',
  PAYMENT_FAILED: 'payment_failed',
  DELETED: 'deleted',
} as const

export const PAID_PREPAYMENT_STATUSES: readonly string[] = [
  PREPAYMENT_STATUS.OPEN,
  PREPAYMENT_STATUS.PAID,
  PREPAYMENT_STATUS.FULLY_PAID,
  PREPAYMENT_STATUS.CREDITED,
]

export function isPrepaymentLinkSent(status?: string | null): boolean {
  return status === PREPAYMENT_STATUS.LINK_SENT
}

export function isPrepaymentAlreadyActive(
  prepaymentType?: string | null,
  prepaymentStatus?: string | null,
): boolean {
  if (prepaymentType !== 'online_payment' || !prepaymentStatus) return false
  return (
    prepaymentStatus === PREPAYMENT_STATUS.LINK_SENT ||
    prepaymentStatus === PREPAYMENT_STATUS.OPEN ||
    prepaymentStatus === PREPAYMENT_STATUS.PAID ||
    PAID_PREPAYMENT_STATUSES.includes(prepaymentStatus)
  )
}

type GetPrepaymentLabelOptions = {
  fallback?: string | null
  prepayment?: boolean | null
}

const LABELS = {
  prepayment: {
    waiting: 'Odottaa ennakkomaksua',
    completed: 'Ennakkomaksu suoritettu',
    failed: 'Ennakkomaksu epäonnistunut',
    credited: 'Ennakkomaksu hyvitetty',
  },
  payment: {
    waiting: 'Odottaa maksua',
    completed: 'Maksu suoritettu',
    failed: 'Maksu epäonnistunut',
    credited: 'Maksu hyvitetty',
  },
} as const

export function getPrepaymentLabel(
  statusDescription: string | null | undefined,
  options?: GetPrepaymentLabelOptions,
): string | null {
  const labels = options?.prepayment === false ? LABELS.payment : LABELS.prepayment

  switch (statusDescription) {
    case PREPAYMENT_STATUS.DRAFT:
    case PREPAYMENT_STATUS.LINK_SENT:
      return labels.waiting
    case PREPAYMENT_STATUS.OPEN:
    case PREPAYMENT_STATUS.PAID:
    case PREPAYMENT_STATUS.FULLY_PAID:
      return labels.completed
    case PREPAYMENT_STATUS.LINK_EXPIRED:
    case PREPAYMENT_STATUS.PAYMENT_NON_TRACKABLE:
    case PREPAYMENT_STATUS.PAYMENT_FAILED:
      return labels.failed
    case PREPAYMENT_STATUS.CREDITED:
      return labels.credited
    case PREPAYMENT_STATUS.DELETED:
      return null
    default:
      return options?.fallback ?? null
  }
}
